import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { useState as p } from "react";
import d from "./useModal.js";
import { tv as m } from "tailwind-variants";
import { I as u } from "./chunks/index-CgDhSQ6a.js";
import f from "./Modal.js";
const v = m({
  slots: {
    wrapper: ["flex", "flex-col", "gap-4"],
    tab: [
      "bg-neutral-200",
      "font-bold",
      "font-secondary",
      "italic",
      "px-3",
      "py-[0.125rem]",
      "rounded-full",
      "text-neutral-500",
      "text-sm",
      "transition-colors",
      "uppercase",
      "hover:bg-neutral-300"
    ]
  },
  variants: {
    isActive: {
      true: {
        tab: ["bg-blue-500", "text-white", "hover:bg-blue-600"]
      }
    }
  }
}), { wrapper: b, tab: x } = v(), I = ({ className: i, images: t, title: c }) => {
  const [l, r] = p(0), a = d();
  return /* @__PURE__ */ n("div", { className: b({ class: i }), children: [
    /* @__PURE__ */ e(
      "button",
      {
        "aria-label": "Open image gallery",
        className: "aspect-[4/3] relative rounded-lg overflow-hidden w-full",
        onClick: a.open,
        children: /* @__PURE__ */ e(
          u,
          {
            alt: `${t[l].title} preview`,
            fill: !0,
            className: "object-cover",
            src: t[l].preview,
            width: 700
          }
        )
      }
    ),
    /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-2 justify-center", children: t.map((o, s) => /* @__PURE__ */ e(
      "button",
      {
        className: x({ isActive: s === l }),
        onClick: () => r(s),
        children: o.title
      },
      o.title
    )) }),
    /* @__PURE__ */ e(
      f,
      {
        activeIndex: l,
        images: t,
        modal: a,
        setActiveIndex: r,
        title: c
      }
    )
  ] });
};
export {
  I as default
};
